module.exports = __webpack_public_path__ + "img/tile-oth1.33149735.jpg";